import { MouseEvent } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { PrivacyPolicyModel } from 'shared/api/PrivacyPolicyModel'
import { usePrivacyPolicyDocument } from 'shared/hooks'

import s from './styles.module.scss'

interface CalculationFooterProps {
  price: string
}

export const CalculationFooter = ({ price }: CalculationFooterProps) => {
  const { t } = useTranslation()
  const { openPrivacyPolicy } = usePrivacyPolicyDocument()

  const onDocumentClick = (
    event: MouseEvent<HTMLButtonElement>,
    field: keyof PrivacyPolicyModel,
  ) => {
    event.stopPropagation()
    void openPrivacyPolicy(field)
  }

  return (
    <div className={s.footerContent}>
      <div className={s.totalRow}>
        <span className={clsx(s.totalLabel, 'bold-16')}>
          {t('insurance.vzr.calculation.total')}
        </span>
        <span className={clsx(s.totalValue, 'extra-bold-18')}>{price}</span>
      </div>

      <div className={s.agreement}>
        <span className={clsx(s.agreementText, 'regular-12')}>
          {t('insurance.vzr.calculation.agreement')}{' '}
          <button
            type="button"
            className={s.documentLink}
            onClick={(event) => onDocumentClick(event, 'public_offer_tfi_mt')}
          >
            {t('insurance.vzr.calculation.public_offer')}
          </button>{' '}
          {t('insurance.vzr.calculation.and')}{' '}
          <button
            type="button"
            className={s.documentLink}
            onClick={(event) => onDocumentClick(event, 'tfi_public_offer')}
          >
            {t('insurance.vzr.calculation.insurance_rules')}
          </button>
          {t('insurance.vzr.calculation.agreement_end')}
        </span>
      </div>
    </div>
  )
}
